<template>
<div class="chapter">
<div class="inner_page">
<div class="body">
<section epub:type="dedication" role="doc-dedication">
<p class="LINESPACE" id="ded"> </p>
<p class="LINESPACE"> </p>
<p class="DED">Dedicated to the Leicester Writers’ Club</p>
</section>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?f1e0f10a